import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import remarkGfm from 'remark-gfm'
import { TranscriptFormattedViewOptions } from './TranscriptFormattedViewOptions'
import { useFormattedExportStore } from './useFormattedExportStore'

const PreTag = (props) => {
  return <pre className="overflow-hidden whitespace-pre-wrap" {...props} />
}

export const TranscriptFormatterView = () => {
  const { exportTranscript } = useFormattedExportStore()
  const markdownContent = exportTranscript() || ''
  const formattedContent = '```\n' + markdownContent + '\n```'
  return (
    <div className="flex w-full flex-col gap-x-4 gap-y-4 py-6 lg:flex-row lg:gap-y-0">
      <div className="max-h-[400px] w-full flex-1 overflow-y-scroll lg:min-w-[500px] lg:max-w-lg">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          className="whitespace-pre-wrap text-xs lg:prose"
          components={{
            pre: PreTag,
          }}
        >
          {formattedContent}
        </ReactMarkdown>
      </div>
      <div className="lg:w-lg w-full lg:pr-12">
        <TranscriptFormattedViewOptions />
      </div>
    </div>
  )
}
